import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CLOSER_SYNC_DRAWER_VIEW } from '../../closer-sync.component';
import { BusinessUser } from '@models/businesses';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-settings-drawer',
	templateUrl: './closer-sync-settings-drawer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncSettingsDrawerComponent implements OnInit {
	@Input() currentUserId: string;
	@Output() closeDrawer = new EventEmitter<CLOSER_SYNC_DRAWER_VIEW.SETTINGS>();
	@Select(BusinessUsersState.getLoggedInBusinessUser)
	getLoggedInBusinessUser$: BusinessUser;
	@Select(BusinessUsersState.getUser) getUser$: Observable<
		(id: string) => BusinessUser
	>;

	ngOnInit(): void {
		this.getUser$.subscribe((userFn) => {
			const user = userFn(this.currentUserId);
			if (!user?.closerSyncId) {
				this.close();
			}
		});
	}

	close(openSettingsDrawer?: CLOSER_SYNC_DRAWER_VIEW.SETTINGS): void {
		this.closeDrawer.emit(openSettingsDrawer);
	}

	openActionsRequiredDrawer() {
		this.close(CLOSER_SYNC_DRAWER_VIEW.SETTINGS);
	}
}
